module.exports = __webpack_public_path__ + "img/banner2.41f79585.png";